import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { VoidAction } from "../../util/func";
import { useState, useEffect } from "react";
import StyledButton from "../StyledButton";

export default function LoadingDialog({ opened, promise, onClose }: { opened: boolean; promise: () => Promise<unknown>; onClose: VoidAction }) {
  const [loading, setLoading] = useState(opened);
  useEffect(() => {
    if (!opened) {
      return;
    }
    setLoading(true);
    (async () => {
      try {
        await promise();
      } finally {
        setLoading(false);
      }
    })();
  }, [opened, promise]);

  return (
    <Dialog open={opened} onClose={() => { !loading && onClose() }}>
      <DialogTitle>{loading ? "処理中" : "処理完了！"}</DialogTitle>
      <DialogContent>
        <Typography>{ loading ? "現在データを処理中です。しばらくお待ちください。" : "データの処理が完了しました！" }</Typography>
      </DialogContent>
      <DialogActions>
        <StyledButton buttonStyle="secondary" onClick={() => { !loading && onClose() }} disabled={loading}>
          閉じる
        </StyledButton>
      </DialogActions>
    </Dialog>
  );
}
